import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams, useRouteMatch } from 'react-router-dom';

import LanguagePicker from '../../../components/language-picker/LanguagePicker';
import { RootState } from '../../../core/state/state';
import { getProjects } from '../../../core/state/project/asyncActions';
import { AuthStatus } from '../../../core/enums/AuthStatus';
import HeaderUserMenu from './HeaderUserMenu';
import Icon from '../../../components/icon/Icon';
import { COMPANY_CONTACTS, HOME_ROUTE, PROFILE } from '../../../core/constants/routes';
import { isAzureAccount } from '../../../core/utils/isAzureAccount';
import HeaderNotification from './header-notification/HeaderNotification';
import Image from '../../../components/image/Image';
import logo from '../../../../img/logo.svg';
import { isMobileScreenSize } from '../../../core/utils/isMobileScreenSize';
import { BASE_URL } from '../../../core/constants/api';

import './Header.scss';

const Header: React.FC = () => {
  const status = useSelector((state: RootState) => state.auth.status);
  const dispatch = useDispatch();
  const isAuthenticated = status === AuthStatus.Authenticated;
  const { path } = useRouteMatch<{ path: string }>();
  const { projectId, userId } = useParams<{ projectId: string; userId: string }>();
  const isMobileScreen = isMobileScreenSize();

  const subcontractorProjectId = useSelector((state: RootState) => state.user.userInfo?.projectID);
  const project = useSelector((state: RootState) => state.projects.projects?.find((item) => item.id === Number(projectId)));
  const internalUser = useSelector((state: RootState) => state.users.internalUsers?.find((item) => item.id === Number(userId)));

  const logoRedirectionPath = () => {
    switch (path) {
      case PROFILE:
      case COMPANY_CONTACTS:
        return `/projects/${subcontractorProjectId}/bookings`;
      default:
        return isAzureAccount ? HOME_ROUTE : `/projects/${projectId}/bookings`;
    }
  };

  React.useEffect(() => {
    dispatch(getProjects(true));
  }, [projectId, dispatch]);

  return (
    <div className="header">
      <div className="d-flex align-items-center">
        <Link to={logoRedirectionPath()}>
          <Image className={`header__logo ${isMobileScreen && 'mr-0'}`} src={logo} alt="logo" />
        </Link>
        {projectId && project && (
          <>
            <Image className="header__img" src={`${BASE_URL}/${project?.photo}`} alt="project-image" />
            <span>
              <b className="mx-3">{project.name}</b>
              {`${project.code} / ${project.constructionSite} / ${project.constructionArea}`}
            </span>
          </>
        )}
        {userId && internalUser && (
          <>
            <Icon icon="projectsRed" svg />
            <span>
              <b className="mx-3">{`${internalUser.firstName} ${internalUser.lastName}`}</b>
              {internalUser.roleName}
            </span>
          </>
        )}
      </div>

      <div className="d-flex align-items-center">
        <LanguagePicker />
        {isAuthenticated && (
          <>
            <Icon className="header__icon" icon="support" size="small" svg />
            <HeaderNotification />
            <HeaderUserMenu />
          </>
        )}
      </div>
    </div>
  );
};

export default Header;
